import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
declare var $ :any;
declare var createCalendar : any;

@Component({
  selector: 'app-addtocalendar',
  templateUrl: './addtocalendar.component.html',
  styleUrls: ['./addtocalendar.component.css']
})
export class AddtocalendarComponent implements OnInit, AfterViewInit {

  constructor() { }
  @Input() elementId : any;
  @Input() eventFeed : any;
  ngOnInit() {}
  ngAfterViewInit(){
        var eventDescription = (this.eventFeed.eventDescription != undefined && this.eventFeed.eventDescription != '') ? $($.parseHTML(this.eventFeed.eventDescription)).text() : '';
        var myCalendar = createCalendar({
          options: {
            class : 'innerCalendar-'+this.elementId,
            id: 'innerCalendar-'+this.elementId          // You need to pass an ID. If you don't, one will be generated for you.
          },
          data: {
            title: this.eventFeed.title,                 // Event title
            start: new Date(this.eventFeed.startTime),   // Event start date
            /*duration: 120,*/                           // Event duration (IN MINUTES)
            end: new Date(this.eventFeed.endTime),       // You can also choose to set an end time.
                                                         // If an end time is set, this will take precedence over duration
            address: this.eventFeed.buildingId[0].formattedAddress,
            description: eventDescription
          }
        });
        $('.outerCalender-'+this.elementId).append(myCalendar);
  }

}
